import React, { Component } from "react";
import { connect } from 'react-redux';
import { getReceivingReports } from "redux/actions/report-actions";
import { getContent } from '../../../redux/actions/comment-actions'
import ReactValidator from "simple-react-validator";
import { Row, Col, Grid } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { dateFormatMy, columnFilters, createSortString, closeModal } from 'helper/helperFunctions';
import Pagination from 'components/ThemeComponents/Pagination';
import { Link } from 'react-router-dom';
import { orderService } from "../../../services/order";
import OpenModalButton from 'components/ThemeComponents/openModelButton';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { ThemeFunctions as TF } from 'helper/ThemeFunctions';
import CopyToClipboard from 'react-copy-html-to-clipboard';
import CKEditor from "react-ckeditor-component";
var Modal = require('react-bootstrap-modal');
const moment = window.moment;

class WtkDigitalDeliveryDashboard extends Component {
	constructor(props) {
		super(props);
		this.validator = new ReactValidator();
		this.state = {

			numOfDays: 30,
			collapseUiSettings: true,
            openResourceModal: false,
			order_details: {},
            stepModalContent: {
				currentStep: null,
				content: null,
				subject: null,
				emails: ['testEmail1', 'testEmail2'],
				title: 'Digital Delivery Email Template',

			}
		}
	}
	getDigitalDeliveryListWtk = (data) => {
        let matchFilterWith;
        if (this.pagination) {
            if (this.pagination.reactTable) {
                matchFilterWith = columnFilters(this.pagination.reactTable.state.columns[0].columns)
            }
        }
        let sorted = data.sort.split(',');
        let { sort, orderType } = createSortString(sorted);
        return orderService.getDigitalDeliveryListWtk(data.page, data.pageSize, sort, orderType, data.filter, matchFilterWith);
    }


	componentDidUpdate(prevProps, prevState) {
		if (prevState.numOfDays !== this.state.numOfDays) {
			this.pagination.dataCall();
		}
	}
	handleChangeContactLogDays = (selectedOptionType, info) => {
		if (info['action'] === 'select-option') {
			this.setState({ numOfDays: selectedOptionType['value'] });
		}
	}
	openModal = (original) => {
		this.setState({order_details: original});
		let slug = original.program_type.title.includes('Mozaix Only') ? 'wtk_mozaix_only' : 'wtk_video_and_mozaix';
		
        this.props.getContentCall(24, original.id, slug).then(
            response => {
                this.setState({ stepModalContent: { ...this.state.stepModalContent, ...response.transmittalTemplate } }, () => {
                    this.setState({ openResourceModal: true });
                });
            }
        ).catch(function (err) {
            console.log(err);
        });
    }
	onChange = (key) => (evt) => {
		var newContent = evt.editor.getData();
		this.setState({ stepModalContent: { ...this.state.stepModalContent, [key]: newContent } })
	}
	render() {
		const { collapseUiSettings, numOfDays, stepModalContent, openResourceModal, order_details} = this.state;
        const tooltipFontSize = { fontSize: '13px' };
		const copiedText = order_details && order_details.group_leader_contacts && order_details.group_leader_contacts.map((contact, index) => {
		  return `${contact.first_name} &lt;${contact.email}&gt;`;
	  	}).join('; ');
		const columns = [
			{
				Header: "Report Testing",
				headerClassName: 'headerPagination',
				columns: [
					{
						Header: "Barcode",
						accessor: "barcode",
						className: "action-center",
						Cell: ({ value, original }) => {
							return <Link to={'/Admin/' + (original.reorder ? original.reorder : original.id) + '/lab-production-report'} target="_blank" className="blue_link">{value}</Link>
						},
                        width: 200,
					},

					{
						Header: "Group Name",
						accessor: "group_name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Departure Date",
						accessor: "order_dates.departure_date",
						Cell: ({ value }) => (
							<div>
								{dateFormatMy(value.value)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Submission Date",
						accessor: "settings.photos_submitted_for_video_production",
						Cell: ({ value }) => (
							<div>
								{dateFormatMy(value.updated_at)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Video Special Need Date",
						accessor: "order_dates.video_special_need_date",
						Cell: ({ value }) => (
							<div>
								{dateFormatMy(value.value)}
							</div>
						),
						className: "action-center redText",
						sortable: false,
					},

					{
						Header: "Upload Cut off date",
						accessor: "order_dates.upload_cut_off_date",
						Cell: ({ value }) => (
							<div>
								{dateFormatMy(value.value)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Number of Photos",
						accessor: "originalImages",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Submitted By",
						accessor: "settings.photos_submitted_for_video_production.updated_by_user",
						className: "action-center",
						sortable: false,
                        Cell: ({ original, value }) => (
                            console.log("original", value),
							<div>
								{
                                    value.id === 91
                                        ?
                                        <span>System</span>
                                         :
                                          value.roles[0].label === "Photo Admin"
                                           ?
                                           <span>PA</span>
                                            :
                                             <span>GTV rep</span>

                                }
							</div>
						),
					},
					{
						Header: "Email Template",
						accessor: "id",
						Cell: ({ original }) => (
							<div>
								<OpenModalButton
									openModal={() => this.openModal(original)}
									classButton={['btn-link p-none']}
									buttonName={'Email Template'}
									tooltipText={'Email Template'}
									classIcon={[]}
								/>
							</div>
						),
						className: "action-center"
					},
				]
			}
		];
		return (
			<div className="content">
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<div className="row">
                                                <Col md={12}>
                                                    <div className="secHeading">
														WTK Digital Delivery Dashboard
                                                    </div>
												</Col>
												
												<Col md={12} className="mt-md">
													<Pagination
														ref={(p) => this.pagination = p}
														columns={columns}
														getDataCall={this.getDigitalDeliveryListWtk}
														filterView={false}
														pageSize={100}
													/>
												</Col>

											</div>
										</Grid>
									</div>
								} />
						</Col>
					</Row>
				</Grid>
				{
					stepModalContent.content && order_details &&
					<Modal backdrop={'static'} show={openResourceModal} onHide={closeModal.bind(this, "openResourceModal")} aria-labelledby="ModalHeader" id="csrDialogue" >
						<Modal.Header closeButton>
						{
							<Modal.Title id='ModalHeader' className="headerTitle">
								<React.Fragment>
									<div className="flexElem8 alignCenter spaceBetween">
										<div>
											{`${stepModalContent.title}`}
										</div>

										<div className="copyEMails">
											<span>
												<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><p style={tooltipFontSize}>Copy Group Leader Email</p></Tooltip>}>
													<CopyToClipboard text={ copiedText
														// order_details.group_leader_contact.first_name + ' &lt;' + order_details.group_leader_contact.email + '&gt;'
													}
													options={{ asHtml: true }}
													>
															<button className="orderDetailsAction copyColorAction" type="button">&nbsp;</button>
													</CopyToClipboard>
												</OverlayTrigger>
												{`Group Leader Email: ${order_details.group_leader_contact.email}`}
											</span>
											{/* {
												
												Object.keys(order_details.group_leader_contacts).length > 1 &&
												<div>
													<button name='show_all_contacts' onClick={this.contactModal} className='actionBtn primaryBtn' style={{font: 'revert', marginTop: '5px'}}>Show All Contacts</button>
												</div>
											} */}

											{
												<span style={{color:"gray"}}>
													<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip" ><span style={tooltipFontSize}>Copy Agency Sales Rep Email</span></Tooltip>}>
														<CopyToClipboard text={order_details.agency_sales_rep.name + ' &lt;' + order_details.agency_sales_rep.email + '&gt;'}
															options={{ asHtml: true }}>
																<button style={{background:"none", paddingTop:"5"}} className="orderDetailsAction copyColorAction1" type="button"><svg xmlns="http://www.w3.org/2000/svg" stroke="#2F4576" fill="gray" stroke-width="0" viewBox="0 0 448 512" height="0.7em" width="0.7em" style={{color: "rgb(51, 51, 51)", fill: "gray"}}><path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path></svg></button>
														</CopyToClipboard>
													</OverlayTrigger>
													{`Agency Sales Rep Email: ${ order_details.agency_sales_rep.email}`}
												</span>
												
											}

											{
												<span>
													<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip"><span style={tooltipFontSize}>Copy to Clipboard</span></Tooltip>}>
														<CopyToClipboard text={
															`${order_details.agency.publishable_agency_name}: App Confirmation & Program Summary for your upcoming trip`
															}
															options={{ asHtml: true }}>
																<button className="orderDetailsAction copyColorAction" type="button">&nbsp;</button>
														</CopyToClipboard>
													</OverlayTrigger>
													{`${order_details.agency.publishable_agency_name}: App Confirmation & Program Summary for your upcoming trip`}
												</span>
											}
										</div>

									</div>
								</React.Fragment>
							</Modal.Title>
								
						}
					</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-md-12">
									<Card bsClass={['innerCard mb-none']} content={
										<CKEditor
											activeClass="p10"
											content={stepModalContent.content}
											events={{
												"change": this.onChange('content')
											}}
										/>
									} />
									{
											TF.mailToEmailsSubject('Emails to Outlook', `${order_details.group_leader_contact.first_name} <${order_details.group_leader_contact.email}>`, stepModalContent.subject)
									}
									<span>&nbsp;</span>
									<CopyToClipboard text={
										stepModalContent.content
									}
										options={{ asHtml: true }}
									>
										<button className="orderDetailsAction copyColorAction" type="button">
											<OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><span style={tooltipFontSize}>Content Copy</span></Tooltip>}>
												<span className="question_mark">?</span>
											</OverlayTrigger>
										</button>
									</CopyToClipboard>
								</div>
							</div>
						</Modal.Body>
					</Modal>

				}
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		getReceivingReportsCall: (data) => { return dispatch(getReceivingReports(data)) },
		getContentCall: (account_id, order_id, code) => { return dispatch(getContent(account_id, order_id, code)) },
	});
};

function mapStateToProps(state) {
	return {
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(WtkDigitalDeliveryDashboard);
